import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CancelIcon from '@mui/icons-material/Cancel';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const AttendanceStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Total Records
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <AccessTimeIcon color="primary" />
              <Typography variant="h5">{stats.total_records || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Present
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <CheckCircleIcon sx={{ color: 'success.main' }} />
              <Typography variant="h5">{stats.present_count || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Absent
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <CancelIcon sx={{ color: 'error.main' }} />
              <Typography variant="h5">{stats.absent_count || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              On Leave
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <ScheduleIcon sx={{ color: 'warning.main' }} />
              <Typography variant="h5">{stats.on_leave_count || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

AttendanceStatsCards.propTypes = {
  stats: PropTypes.shape({
    total_records: PropTypes.number,
    present_count: PropTypes.number,
    absent_count: PropTypes.number,
    on_leave_count: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default AttendanceStatsCards;